"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDynamicVariant = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var getDynamicVariant = function getDynamicVariant(value, scale) {
  var _getFinalScale;
  var getFinalScale = function getFinalScale() {
    if (_typeof(value) !== 'object') return;
    if (!scale) return 'sm';
    if (value[scale]) return scale;
    if (!value[scale] && scale == 'lg') {
      return value['md'] ? 'md' : 'sm';
    } else if (!value[scale] && scale === 'md') 'sm';
    return 'sm';
  };
  return value && _typeof(value) === 'object' ? value[(_getFinalScale = getFinalScale()) !== null && _getFinalScale !== void 0 ? _getFinalScale : 'sm'] : value;
};
exports.getDynamicVariant = getDynamicVariant;